const colors = [
    '#f5d7ce',
    '#f5cec1',
    '#e6c0b3',

    '#e8e4b3',
    '#e9ebb7',
    '#e0e8ac',

    '#d5e8ac',
    '#d7eda6',
    '#caeda6',

    '#caeda6',
    '#a6d2ed',
    '#95bbe8'
]

const options = [

    'D/I',
    'D/S',
    'D/C',

    'I/D',
    'I/S',
    'I/C',

    'S/D',
    'S/I',
    'S/C',

    'C/D',
    'C/I',
    'C/S'
]

const subTraitDetails = [
    {
        head: `Di styles tend to be results-oriented, vocal, and enthusiastic, influencing others
        through their powerful charm and bold action.`,
        body1: `Efficiency appears when Dominance is significantly higher than
      Influence. An 'efficient' individual is assertive and has little or no
      interest in personal matters. They take a direct, analytical view towards their goals withrelentless persistence. They need to see results, and
      are quite willing to compromise quality or detail to get them.`,
        qualities: {
            traits: `dynamic, inquisitive, persuasive, rebellious, restless, entrepreneurial, results oriented, vocal, enthusiastic`,
            goals: `quick action, new opportunities`,
            fears: `being undetectable, invisibility or unrecognized`,
            influence: `through charm and daring actions`,
            anticipate: `impatience, egotism, manipulation`,
            conflict: `addresses issues head-on; may say things they will regret`,
            improve: `patience, humility, consideration of others’ ideas`,
            leadership: `Di-style are typically pioneering leaders, determined to constantly seek out opportunities and achieve results`
        }
    },
    {
        head: `DS-style leaders are often commanding and confident, taking care and focusing on results.`,
        body1: `Self-motivation displays when Dominance is significantly higher
    than Steadiness. Action is a primary ingredient as this style feels a need to
    be active all the time, and is impatient with those who are unwilling to
    keep up with their pace. They are incredibly reactive, but
    never lose sight of their own goals and ambitions.`,
        qualities: {
            traits: `friendly, reliable, persistent, hard-working, determined, harmonious`,
            goals: `pushing through to get it done, no matter the barrier`,
            fears: `not being able to accomplish the task at hand`,
            influence: `workaholic, stubborn`,
           anticipate: `committed work ethic`,
            conflict: `Can be stubborn with unique combination of wanting to be friendly and wanting to resolve the conflict swiftly`,
            improve: `showing more patience and making time to communicate with others`,
            leadership: `DS-style leaders are optimistic about future endeavors, always willing to reach new heights, and most critically, achieve results`
        }
    },
    {
        head: `DC-styles tend to be diligent, tough-minded, and creative, influencing others
    through their high standards, will and determination.`,
        body1: `Objectivity, a combined trait found most prominently showing both high
    Dominance and high in Compliance. This style takes on a serious approach, concerned with ensuring high standards
    from themselves and those around them.`,
        body2:
            `Independence appears in a profile when Dominance is
    significantly higher than Compliance. This type of person grows frustrated by oversight hindered by rules
    and regulations - they prefer to follow their own path, often working alone or in
    positions of isolated authority.`,
        qualities: {
            traits: `driven to perfection, takes initiative; diligent, determined, creative, critical, cool, focused, tough-minded`,
            goals: `independence, personal accomplishment`,
            fears: `failure to achieve their own standards`,
            influence: `high standards, determination`,
            anticipate: `bluntness, sarcastic or condescending attitude`,
            conflict: `sticks up for themselves; digs in their heels`,
            improve: `consideration and tactful communication `,
            leadership: ` DC-style leaders are often resolute, setting high
            expectations and speaking up about problems. They tend to be concerned with
            improving methods and procedures`
        }
    },
    {
        head: `iD styles tend to be high-energy, charismatic, and adventurous, influencing others
    through their boldness and passion.`,
        body1: `Assertiveness: A combined trait found most prominently in profiles showing both
    high Dominance and high Influence. Individuals of this kind are confident and
    unafraid to express their opinions, capable of a drive of determination in challenging situations).`,
        body2: `Friendliness: unreserved and a love to discuss ideas - communication is the strongest element
    of this style. Since they are outgoing and lively, they can often find themselves easily distracted from such mundane work by the
    opportunity for social interaction..`,
        qualities: {
            traits: `high-energy, poised, persuasive, open, ambitious, self-promoting, influential,
        impatient, adventurous, charismatic`,
            goals: ` popularity, exciting breakthroughs, prestige`,
            fears: `fixed environments, loss of approval or attention`,
            influence: `boldness, passion`,
            anticipate: `impulsiveness, outspokenness`,
            conflict: `expresses feelings, becomes overly dramatic`,
            improve: ` focusing on details, patience, listening to
            others`,
            leadership: `will seek to stretch boundaries, find opportunities, and inspire
            action in others. This can be perceived as pushy, intimidating, or insincere`
        }
    },
    {
        head: `iS styles tend to be warm, friendly, and sociable, influencing others through their
        agreeableness and empathy.`,
        body1: `Sociability: A combined trait found most prominently in profiles showing both high
        Influence and high Steadiness. With both the socially oriented factors high in their
        profile, individuals of this kind tend to focus on the interactions with those around them. `,
        body2: `Enthusiasm: This is an outgoing and extrovert sub-trait that has much in common
        with Friendliness, but with the added dimension of energy and pace. This style shows their interest in a topic very animated fashion, and their effusive nature acts
        as a motivating factor for others.`,
        qualities: {
            traits: `warm, friendly, accepting, collaborative, empathetic, upbeat, punctual, conflict-averse, cheerful, sociable`,
            goals: `connection and embrace`,
            fears: `pressuring others, being disliked`,
            influence: `agreeableness, empathy`,
            anticipate: `patience with others, indirect approaches`,
            conflict: `seeks emotional support, dwells on wounded relationships`,
            improve: `acknowledging others’ flaws, confronting
                problems`,
            leadership: `will be supportive, respectful, and positive; at time, can also be indirect and
                conflict-averse`
        }
    },
    {
        head: `iC-style leaders are naturally brave and self-confident, like to know all the pieces of the puzzle, and will adapt to any situation`,
        body1: `Self-confident: a trait of this profile which represents people who rarely experience
        self-doubt, and feel at ease in almost any social situation. They mix easily with
        strangers, and certainly not afraid to initiate any social contact. They can at times become
        over-confident, leading them to act impulsively.`,
        qualities: {
            traits: `imaginative, enthusiastic, detail-oriented, critical`,
            goals: ` turning dreams into working systems`,
            fears: `having ideas undervalued, not heard or losing the respect of other`,
            influence: `quality is in the details`,
            anticipate: `intensity to detail and work; critical`,
            conflict: `may look for the groups approval; can dominate the conversation and make it so only they are heard`,
            improve: `accepting and growing from criticism and praising others`,
            leadership: `Detail-driven and carries a verbal intensity that lights a fire under everyone's bum to meet the standard of excellence set forth`
        }
    },
    {
        head: `SD-style leaders are natural collaborators who like to reach consensus and create
        win-win situations. This strive for balance can sometimes be passive and overly trusting,
        letting others take advantage of their supportive, patient nature.
        `,
        body1: `Patience: This is a style of person who has little sense of urgency which
        means that they are able to work carefully in situations that others would find repetitive or
        dull. They are submissive in style, and ready to accept that there are some things
        that they cannot change.`,
        qualities: {
            traits: `patient, tenacious, dependable, observant, practical`,
            goals: `finish whatever is started`,
            fears: `not getting the result`,
            influence: `how they treat others around them`,
            anticipate: `overuse of selflessness, empathy`,
            conflict: `withdraws and can lash out under pressure`,
            improve: `not always trying to preserve the harmony`,
            leadership: `will be inclusive, humble about their achievements, and affirming and uplifting to those around them`
        }
    },
    {
        head: `Si styles tend to be generous, approachable, and compassionate and influencing
        others by showing empathy and patience.`,
        body1: `Thoughtfulness: Thoughtful individuals plan their words and actions carefully and
        never act on impulse. Deadlines and other time constraints are difficult for this type
        of person to deal with. Their advantage, however, is the reliability and steadiness
        that they bring to their work.`,
        qualities: {
            traits: `collaborative, well-liked, team-spirited, positive, encouraging, avoids conflict, approachable, generous, compassionate
            `,
            goals: `acceptance, close relationships`,
            fears: `being forced to pressure others; facing aggression`,
            influence: ` showing empathy, being patient`,
            anticipate: `kindness, personal connections; overburdens oneself with work`,
            conflict: `shows empathy, glosses over problems`,
            improve: `saying “no” when necessary; addressing
                issues`,
            leadership: `Si-style leaders tend to be laid back, trusting, and supportive
                of their staff and colleagues. This can result in difficulty confronting
                problems and acknowledging others’ flaws.`
        }
    },
    {
        head: `SC styles tend to be accommodating, patient, and reliable, influencing others
        through diplomacy and self-control`,
        body1: `Technical Potential: A combined trait found most prominently in profiles showing
        both high Steadiness and high Compliance. Individuals of this kind commonly
        possess the patience and analytical patterns to focus on complex tasks and find
        workable solutions to difficult problems.`,
        body2: `Persistent people may struggle with change. Once they have become
        established in a status quo, they find it very difficult to break out of this and adapt
        to a new situation. They will do what they can to maintain their
        current state of affairs, showing great loyalty and resilience in defense of their
        present environment and circle`,
        qualities: {
            traits: `stable, consistent, predictable, accommodating, patient, inflexible, self-controlled, reliable, thoughtful, soft-spoken`,
            goals: `calm environment, fixed objectives, steady progress`,
            fears: `time pressure, uncertainty, chaos`,
            influence: ` diplomacy, self-control, consistency`,
            anticipate: `willingness to let others lead; humility`,
            conflict: ` encourages a calm demeanor; retreats from the conflict`,
            improve: ` initiating change, speaking up`,
            leadership: `SC-style leaders can be modest and fair-minded, providing
                reliable outcomes through steadiness and consistency. They can also be rigid,
                overly cautious, and afraid to move beyond the line they've drawn`
        }
    },
    {
        head: `CD styles tend to be skeptical, stubborn, and disciplined, influencing others
        through their strict standards and resolute approach.`,
        body1: `Cooperativeness: This sub-trait relates to a person
        who needs to be absolutely sure of their position and prefers to use established procedures as a framework to support their ideas and actions. Co-operative
        people are so called because their personal style extends to the
        need for practical support from managers, colleagues and friends, and so they may
        seek to maintain positive working relationships with others`,
        qualities: {
            traits: `skeptical, determined, questioning, critical thinker, stubborn,
            objective, disciplined, systematic`,
            goals: `efficient results, rational decisions`,
            fears: ` failure, lack of control`,
            influence: ` strict standards, resolute approach`,
            anticipate: `bluntness, critical attitude`,
            conflict: ` becomes passive-aggressive`,
            improve: `cooperation, paying attention to the needs of
                others`,
            leadership: `CD-style leaders set incredibly high standards and can question every decision to ensure quality. This can get under the skin of sensitive collegues.
                `
        }
    },
    {
        head: `Ci-style leaders can be conscientious, disciplined, and diligent, providing highquality outcomes through careful analysis and planning. They can also be riskaverse perfectionists, who may not pay enough attention to the human element.`,
        body1: `Accuracy: This sub-trait is also sometimes referred to as Caution and reflects the type of person who hates to make mistakes - they check and recheck their
        work, and prone to correct others', whether or not they have been asked
        to do so or not. This need for certainty means that they will never take a risk unless
        absolutely necessary. They are also cautious in communication, rarely revealing
        more about themselves than a bare minimum`,
        qualities: {
            traits: ` enthusiastic, eloquent, careful, fun, critical`,
            goals: `quality and perfection`,
            fears: `condemned for lack of effort`,
            influence: `their consistent character`,
            anticipate: `lacking censors and giving advice (whether asked or not)`,
            conflict: `boils under own skin and complains with those closeby`,
            improve: `not inferring others are doing work of less quality; assume positive intentions`,
            leadership: `tends to be critical and self-disciplined, while expecting that of others around them – intrinsically motivates team to meet perfection`
        }
    },
    {
        head: `CS styles tend to be cautious, orderly, and precise, influencing others through their
        practicality and attention to detail`,
        body1: `Sensitivity: People of this kind are extremely aware of their surroundings and
        changes taking place within it, to the extent that they often notice subtle alterations that
        other people miss or ignore. This constant awareness spawns a very low boredom threshold which can make this type very easily distracted.`,
        qualities: {
            traits: `cautious, reflective, stable, orderly, even-tempered, precise, well-prepared,
            patient, self-controlled`,
            goals: `stable, risk-averse, reliable outcomes`,
            fears: ` emotionally charged situations, ambiguity`,
            influence: `practicality, attention to detail
                `,
            anticipate: `traditional methods, an overly sense of caution`,
            conflict: `encourages a calm demeanor; avoids emotional situations`,
            improve: `showing flexibility, being more decisive,
                displaying a greater sense of urgency`,
            leadership: ` CS-style leaders can be modest, objective and fair-minded while providing
                reliable outcomes through steadiness and consistency. They can also be rigid,
                overly cautious, and afraid to move beyond the status-quo`
        }
    }

]

export { options, subTraitDetails, colors }
